<template>
  <b-button v-if="botao" @click="confirm ? excluir() : habilitarConfirmacao()" size="sm" :disabled="loading"
    :style="'color: ' + cor + ' !important;'">
    <b-spinner v-if="loading" small />
    <font-awesome-icon v-else :icon="icone" />
    <span class="ml-2">{{ texto }}</span>
  </b-button>
  <div v-else class="actions-icons btn-excluir-wrapper">
    <b-link :style="'color: ' + cor + ' !important;'" class="text-dark text-center"
      @click="confirm ? excluir() : habilitarConfirmacao()">
      <b-spinner small v-if="loading" />
      <font-awesome-icon v-else :icon="icone" />
      <span :style="'color: ' + cor + ';'" class="texto-botao">{{ texto }}</span>
    </b-link>
  </div>
</template>

<script>
export default {
  name: "BtnExcluirComponent",
  props: {
    excluirItem: { type: Function, required: true },
    idItem: { required: true },
    botao: { type: Boolean, default: false },
  },
  data() {
    return {
      loading: false,
      confirm: false
    };
  },
  methods: {
    /*     sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    }, */
    async excluir() {
      this.loading = true;
      await this.excluirItem(this.idItem);
      this.loading = false;
    },
    async habilitarConfirmacao() {
      this.confirm = true
      await new Promise(resolve => setTimeout(resolve, 5000));
      this.confirm = false
    }
  },
  computed: {
    icone() {
      return this.confirm ? 'exclamation-circle' : 'trash'
    },

    texto() {
      return this.confirm ? 'Confirmar' : 'Excluir'
    },

    cor() {
      if (this.botao) return this.confirm ? '#e37680' : '#ffffff'
      return this.confirm ? '#dc3545' : '#343a40'
    }
  }
};
</script>
<style scoped>
.text-dark.disabled>span,
.text-dark.disabled:hover {
  color: var(--gray);
  cursor: default;
  text-decoration: none;
}

.btn-excluir-wrapper {
  min-width: 53px;
  justify-content: center;
}
</style>